import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { PartnerWorkflowStatus } from 'clickNgo/entities/partner/configs'
import { TWorkflowStatus } from 'clickNgo/entities/partner/models'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import { PartnerServiceOptions } from '../configs'

export interface IDeleteBasicEditPartnerRequest {
  entryId406: number
  workflowStatus: TWorkflowStatus
  isLastRequest?: boolean
}

export const deleteBasicEditPartnerRequest = ({
  entryId406,
  workflowStatus,
  isLastRequest = true,
}: IDeleteBasicEditPartnerRequest) => {
  const source = CrudStore.get(CrudStoreItem.PartnerAllData, 'delete-edit-partner-request')
  const keyField = 'EntryId'

  const isDone = workflowStatus === PartnerWorkflowStatus.DONE
  const isRejected = workflowStatus === PartnerWorkflowStatus.REJECTED

  if (isRejected || (isDone && isLastRequest)) {
    return source
      .update(PartnerServiceOptions.PARTNERS_EXT, [{ EntryId: entryId406 }])
      .catch((err: string) => {
        Logger.error(err)
        return false
      })
  }

  if (isDone) {
    return source
      .update(PartnerServiceOptions.PARTNERS_EXT, [{ EntryId: entryId406, LastRequest: false }])
      .catch((err: string) => {
        Logger.error(err)
        return false
      })
  }

  if (source.fetcher.delete) {
    return source.fetcher
      .delete(PartnerServiceOptions.PARTNERS_EXT, entryId406, keyField)
      .catch((err: string) => {
        Logger.error(err)
        return false
      })
  }

  return Promise.resolve(false)
}
